<template>
  <div class="lb-search" :class="{'container': position === 'left','containers': position === 'right'}">
    <input type="text" placeholder="输入关键词,按回车键搜索" v-model="currentValue" @keyup.enter="$emit('inputEnter', currentValue)" @input="inputLoad">
    <div class="search"></div>
  </div>
</template>

<script>
export default {
  name: 'lb-search',
  props: {
    value: {
      type: [String, Number],
      required: true,
      default: ''
    },
    position: {
      type: String,
      default: 'left'
    },
    type: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      currentValue: this.value
    }
  },
  watch: {
    value(val) {
      this.currentValue = val
    }
  },
  methods: {
    inputLoad() {
      this.$emit('input', this.currentValue)
    }
  }
}
</script>

<style lang="scss">
  @import "./lb-search.scss"
</style>
